import brandTokens from "./brandTokens";

const isDark = brandTokens.mode === "dark";
const text = isDark ? brandTokens.text.dark : brandTokens.text.light;
const bg = isDark ? brandTokens.backgrounds.dark : brandTokens.backgrounds.light;
const bgAlt = isDark ? brandTokens.backgrounds.dark : brandTokens.backgrounds.lightAlt;

const antdTheme = {
  token: {
    colorPrimary: brandTokens.colors.brand,
    colorInfo: brandTokens.colors.brand,
    colorSuccess: brandTokens.colors.brand,
    colorWarning: brandTokens.colors.brand,
    colorError: "#E14B4B",
    colorTextBase: text.strong,
    colorText: text.normal,
    colorTextSecondary: text.weak,
    colorBgBase: bg,
    colorBgContainer: bg,
    colorBgLayout: bgAlt,
    colorBorder: isDark ? "rgba(255, 255, 255, 0.12)" : "rgba(24, 25, 27, 0.12)",
    colorBorderSecondary: isDark ? "rgba(255, 255, 255, 0.08)" : "rgba(24, 25, 27, 0.08)",
    colorPrimaryHover: "#0FC337",
    colorPrimaryActive: "#0EAF31",
    borderRadius: brandTokens.radius.md,
    borderRadiusLG: brandTokens.radius.lg,
    borderRadiusSM: brandTokens.radius.sm,
    controlHeight: 40,
    controlHeightLG: 44,
    controlHeightSM: 32,
    fontFamily: "\"IBM Plex Sans\", \"Segoe UI\", Arial, sans-serif"
  },
  components: {
    Button: {
      fontWeight: 600,
      controlHeight: 40,
      borderRadius: brandTokens.radius.md
    },
    Card: {
      borderRadius: brandTokens.radius.lg,
      headerBg: bgAlt
    },
    Table: {
      headerBg: bgAlt,
      rowHoverBg: brandTokens.colors.highlight
    },
    Segmented: {
      borderRadius: brandTokens.radius.md
    },
    Tabs: {
      titleFontSize: 14
    },
    Input: {
      borderRadius: brandTokens.radius.md,
      activeBorderColor: brandTokens.colors.brand
    },
    Select: {
      borderRadius: brandTokens.radius.md
    },
    Dropdown: {
      borderRadiusLG: brandTokens.radius.lg
    },
    Modal: {
      borderRadiusLG: brandTokens.radius.lg
    },
    Drawer: {
      borderRadiusLG: brandTokens.radius.lg
    },
    Tooltip: {
      borderRadius: brandTokens.radius.sm
    }
  }
};

export default antdTheme;
